import React, { useContext } from 'react';
import { NavGridContainer, Wrapper } from './CategoryWidget.styles';
import { useState } from 'react';
import NavList from './Components/NavList';
import TempLabourSvg from './svgs/TempLabourSvg';
import TempLabour from './TempLabour';
import { UploadCategoryStateContext } from 'contexts/UploadCategoryStateContext';
import { PermissionsContext } from 'contexts/PermissionsContext';
import SkuAnalysis from './SkuAnalysis/SkuAnalysis';
import { UploadSkuStateContext } from 'contexts/UploadSkuStateContext';
import { UploadSkuStateContextProvider } from 'contexts/UploadSkuStateContext/UploadSkuStateContextProvider';
import StocksSvg from './svgs/Stockssvg';
import { ToastMessageProvider } from 'contexts/ToastMessageContext/ToastMessageProvider';

export const categoryNav = [
	{
		key: 1,
		title: 'Temp Labor',
		icon: TempLabourSvg,
	},
	{
		key: 2,
		title: 'SKU Analysis',
		icon: StocksSvg,
	},
];

const CategoryWidget = () => {
	const { skuStatus } = useContext(UploadSkuStateContext);
	const [currentContent, setCurrentContent] = useState(0);

	const getCurrentContent = key => {
		switch (key) {
			case 0:
				return (
					<NavGridContainer>
						<NavList navArray={categoryNav} setContent={setCurrentContent} />
					</NavGridContainer>
				);
			case 1:
				return <TempLabour setCurrentContent={setCurrentContent} />;
			case 2:
				return (
					<SkuAnalysis
						setCurrentContent={setCurrentContent}
						skuStatus={skuStatus}
					/>
				);
			default:
				break;
		}
	};
	return <>{getCurrentContent(currentContent)}</>;
};

export default props => (
	<UploadCategoryStateContext.Consumer>
		{({ categoryStatus }) => (
			<PermissionsContext.Consumer>
				{({ permissions }) => (
					<ToastMessageProvider>
						<CategoryWidget
							{...props}
							permissions={permissions || []}
							categoryFileStatus={categoryStatus}
						/>
					</ToastMessageProvider>
				)}
			</PermissionsContext.Consumer>
		)}
	</UploadCategoryStateContext.Consumer>
);
